<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>{{ action }} Email List Entry</h3>
    </div>

    <div class="box">
      <div class="row">
        <coin-v2-text-input
          placeholder="Gid"
          label="Gid"
          [disabled]="action === Action.Edit || action === Action.Delete"
          [errorMessage]="validateString(item.Gid)"
          [(ngModel)]="item.Gid"></coin-v2-text-input>
      </div>
      <div class="row">
        <coin-v2-text-input
          placeholder="EmailAddress"
          label="EmailAddress"
          [disabled]="action === Action.Delete"
          [errorMessage]="validateString(item.EmailAddress)"
          [(ngModel)]="item.EmailAddress"></coin-v2-text-input>
      </div>

      <div class="buttons">
        <coin-v2-button
          [type]="'secondary'"
          [icon]="'close'"
          [iconPos]="'right'"
          [text]="'Cancel'"
          (click)="close()"></coin-v2-button>

        @if (action === Action.Edit) {
          <div>
            <coin-v2-button
              [type]="'primary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="'Update'"
              [disabled]="uploading || !validate()"
              (click)="update()"></coin-v2-button>
          </div>
        }

        @if (action === Action.New) {
          <div #new>
            <coin-v2-button
              [type]="'primary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="'Create'"
              [disabled]="uploading || !validate()"
              (click)="create()"></coin-v2-button>
          </div>
        }

        @if (action === Action.Delete) {
          <div #new>
            <coin-v2-button
              [type]="'primary'"
              [icon]="'upload'"
              [iconPos]="'right'"
              [text]="'Delete'"
              [disabled]="uploading || !validate()"
              (click)="delete()"></coin-v2-button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
